module.exports = __webpack_public_path__ + "static/media/6WHEELS_LIFT.8fdc22a6.png";